<template>
  <div class="container-lg">
    <h1 class="page-header">Material</h1>
    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="handleSubmit()" name="form">
        <ValidationProvider name="Type" rules="required" v-slot="{ errors }">
          <div class="form-group row">
            <label class="col-sm-3">Type</label>
            <div class="col-sm-4">
              <select class="form-control" v-model="item.type_id">
                <option v-for="i in material_types" :value="i.id" :key="i.id">
                  {{ i.name }}
                </option>
              </select>
              <span class="text-danger">{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>

        <ValidationProvider name="SKU" rules="required" v-slot="{ errors }">
          <div class="form-group row">
            <label class="col-sm-3">SKU</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" v-model="item.sku" />
              <span class="text-danger">{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>

        <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
          <div class="form-group row">
            <label class="col-sm-3">Name</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" v-model="item.name" />
              <span class="text-danger">{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>

        <div class="form-group row">
          <label class="col-sm-3">Cost</label>
          <ValidationProvider
            name="Cost"
            rules="required"
            v-slot="{ errors }"
            tag="div"
            class="col-sm-3"
          >
            <input
              class="form-control"
              type="number"
              v-model="item.cost"
              min="0"
              max="99999.99"
              step="0.01"
            />
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
          <ValidationProvider
            name="Unit type"
            rules="required"
            v-slot="{ errors }"
            tag="div"
            class="col-sm-3"
          >
            <select class="form-control" v-model="item.unit_id">
              <option v-for="i in unit_types" :value="i.id" :key="i.id">
                {{ i.name }}
              </option>
            </select>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <ValidationProvider name="Colour" rules="" v-slot="{ errors }">
          <div class="form-group row">
            <label class="col-sm-3">Colour</label>
            <div class="col-sm-3">
              <input class="form-control" type="text" v-model="item.color" />
              <span class="text-danger">{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>

        <ValidationProvider name="Weight" rules="" v-slot="{ errors }">
          <div class="form-group row">
            <label class="col-sm-3">Weight</label>
            <div class="col-sm-3">
              <div class="input-group">
                <input
                  class="form-control"
                  type="number"
                  v-model="item.weight"
                  min="0"
                  max="999.99"
                  step="0.001"
                />
                <div class="input-group-text">kg</div>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>

        <div class="form-group row" v-if="has_w || has_h || has_d">
          <label class="col-sm-3">Size</label>
          <div class="col-sm-3" v-if="has_w">
            <ValidationProvider name="Width" rules="required" v-slot="{ errors }">
              <div class="input-group">
                <div class="input-group-text">Width</div>
                <input
                  class="form-control"
                  type="number"
                  v-model="item.w"
                  min="0"
                  max="999.99"
                  step="0.001"
                />
                <div class="input-group-text">mm</div>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-sm-3" v-if="has_h">
            <ValidationProvider name="Height" rules="required" v-slot="{ errors }">
              <div class="input-group">
                <div class="input-group-text">Height</div>
                <input
                  class="form-control"
                  type="number"
                  v-model="item.h"
                  min="0"
                  max="999.99"
                  step="0.001"
                />
                <div class="input-group-text">mm</div>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-sm-3" v-if="has_d">
            <ValidationProvider name="Depth/thickness" rules="required" v-slot="{ errors }">
              <div class="input-group">
                <div class="input-group-text">Depth/thickness</div>
                <input
                  class="form-control"
                  type="number"
                  v-model="item.d"
                  min="0"
                  max="999.99"
                  step="0.001"
                />
                <div class="input-group-text">mm</div>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3">Notes</label>
          <div class="col-sm-9">
            <textarea class="form-control" type="text" v-model="item.notes" />
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-12 text-right">
            <button
              class="btn btn-light mr-4"
              type="button"
              @click="$router.back()"
            >
              Cancel
            </button>
            <button class="btn btn-primary" type="submit" :disabled="invalid">
              Save
            </button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { authFetch } from "../lib/auth.js";

export default {
  props: {
    id: String,
  },
  data() {
    return {
      item: {
        // Add fields here so vue watches all fields for changes
        id: null,
        sku: null,
        name: null,
        type_id: null,
        cost: null,
        unit_id: null,
        color: null,
        weight: null,
        w: null,
        h: null,
        d: null,
        notes: null,
      },
      material_types: [],
      unit_types: [],
    };
  },
  created() {
    this.load();
  },
  watch: {
    id() {
      this.load();
    },
  },
  computed: {
    has_w() {
      const u = this.material_types.find(i => i.id === this.item.type_id)
      return (u && u.has_w)
    },
    has_h() {
      const u = this.material_types.find(i => i.id === this.item.type_id)
      return (u && u.has_h)
    },
    has_d() {
      const u = this.material_types.find(i => i.id === this.item.type_id)
      return (u && u.has_d)
    }
  },
  methods: {
    handleSubmit() {
      if (this.item.postcode) {
        this.item.postcode = this.item.postcode.toUpperCase();
      }
      if (this.item.id) {
        // Update existing
        authFetch("/db/material/" + this.item.id, {
          method: "put",
          body: JSON.stringify(this.item),
        }).then((resp) => {
          switch (resp.status) {
            case 200:
              this.$router.back();
              return;
            default:
              alert(resp.statusText);
          }
        });
      } else {
        // Add new
        authFetch("/db/material", {
          method: "post",
          body: JSON.stringify(this.item),
        }).then((resp) => {
          switch (resp.status) {
            case 200:
              resp.text().then((id) => {
                this.item.id = parseInt(id);
              });
              this.$router.back();
              return;
            default:
              alert(resp.statusText);
          }
        });
      }
    },
    load() {
      authFetch("/db/material_type").then((resp) =>
        resp.json().then((data) => (this.material_types = data))
      );
      authFetch("/db/material_unit").then((resp) =>
        resp.json().then((data) => (this.unit_types = data))
      );
      if (!this.id) {
        this.item = {};
        return;
      } else {
        authFetch("/db/material/" + this.id)
          .then((resp) => resp.json())
          .then((data) => {
            this.item = data;
          });
      }
    },
  },
};
</script>

<style lang="scss">
</style>